import { addInterval, appendPerEntryFeeVoucher, balanceAfterPlan, calculateAmounts, createNewNormalEntry, } from '../index.js';
export const generateByDuration = async (input) => {
    const { duration, interval, feeStructure, documents, economyPolicy, fixedDistributions, reminderTimespan, paymentDeadlineTimespan, cancelTimespan, conditions, } = input;
    let plan = input.plan;
    let filteredVouchers = input.filteredVouchers;
    let currDate = input.currDate;
    if (typeof duration != 'number') {
        throw new Error(`Please provide a number, not a ${typeof duration}`);
    }
    if (duration <= 0) {
        throw new Error(`Duration cannot be less or equals 0`);
    }
    for (let i = 0; i < duration; i++) {
        filteredVouchers = appendPerEntryFeeVoucher(filteredVouchers, feeStructure, currDate.toISOString());
        const newEntry = createNewNormalEntry(currDate, reminderTimespan, paymentDeadlineTimespan, cancelTimespan, 0);
        plan.push(newEntry);
        currDate = addInterval(interval, currDate);
    }
    plan = await calculateAmounts(filteredVouchers, documents, economyPolicy, fixedDistributions, plan, conditions);
    // Adjust last entry to account for rounding differences
    const balance = await balanceAfterPlan(filteredVouchers, documents, economyPolicy, fixedDistributions, plan, conditions);
    if (balance !== 0 && plan.length > 0) {
        plan[plan.length - 1] = {
            ...plan[plan.length - 1],
            amount: plan[plan.length - 1].amount + -balance,
        };
    }
    return { plan, filteredVouchers };
};
//# sourceMappingURL=duration.js.map